import { Component, HostListener } from '@angular/core';
import { Screen } from 'app/screen';
declare var window: any;

@Component({
  selector: 'screen-desktopmenu-desktop',
  templateUrl: 'desktopmenu.html'
})
export class desktopmenu_Desktop extends Screen {
  data: any;
  getScreenWidth:any;
  ngOnInit(): void {
    super.ngOnInit();
    this.data.isExpand = false;
    this.getScreenWidth = window.innerWidth;
    this.global['expandMenuClick']= this.expandMenu.bind(this);
    if(this.getScreenWidth < 1300){
      this.data.minimized = true
      console.log("this.global['toggleExpandMenu']",this.global['toggleExpandMenu'])
      if(this.global['toggleExpandMenu']){
        this.global['toggleExpandMenu'](true)
      }
    }else{
      this.data.minimized = false
    }
    
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    if(this.getScreenWidth < 1300){
      this.data.minimized = true
      if(this.global['toggleExpandMenu']){
        this.global['toggleExpandMenu'](true)
      }
    }else{
      this.data.minimized = false
      if(this.global['toggleExpandMenu']){
        this.global['toggleExpandMenu'](false)
      }
    }
  }
  gotoRevisionReport(){
    this.data.activeTable='revisionList';
    this.go('revisionsreport',this.data)
  }
  expandMenu(){
    console.log("clicked expandMenu desktop menu",this.data.isExpand)
    if(this.data.isExpand){
      this.data.isExpand = false;
    }else{
      this.data.isExpand = true;
      if(this.global['toggleExpandMenu']){
        this.global['toggleExpandMenu'](true)
      }
    }
    this.data.minimized = !this.data.isExpand 
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    // Logic to run when the screen unloads goes here.
  }

  async onDataLoad(data: any): Promise<void> {
    // Logic to run when the screen's data is updated goes here.
  }
  onBackButton(): boolean {
    //(Android) returns :
    // true - handle the event in App Hooks
    // false - stop the event propogation
      return true;
  }

  shrink() {
      this.data.minimized = !this.data.minimized;
  }
}



// WEBPACK FOOTER //
// ./src/pages/desktopmenu/Desktop/desktopmenu.ts